export default {
  CHECK_IN_GRADIENT: 'CHECK_IN_GRADIENT',
};
